import * as actionTypes from '../../constants/actionTypes';

const initialState = {
  isStageIssueDetailsLoading: false,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_STAGE_ISSUE_DETAILS_ERROR:
    case actionTypes.GET_STAGE_ISSUE_DETAILS_SUCCESS:
      return action.payload;
    case actionTypes.SHOW_LOADER:
      switch (action.payload) {
        case actionTypes.GET_STAGE_ISSUE_DETAILS:
          return Object.assign({}, state, { isStageIssueDetailsLoading: true });
        default:
          return Object.assign({}, state);
      }
    case actionTypes.HIDE_LOADER:
      switch (action.payload) {
        case actionTypes.GET_STAGE_ISSUE_DETAILS:
          return Object.assign({}, state, {
            isStageIssueDetailsLoading: false,
          });
        default:
          return Object.assign({}, state);
      }
    case actionTypes.UNLOAD_ISSUE_DETAILS:
      return initialState;
    default:
      return state;
  }
}
